<template>
    <div>
        <div class="d-flex unsub-input mb-3">
            <input placeholder="Enter email to add unsubscribe" type="text" v-model="newEmail" class="form-control" />
            <button class="btn btn-primary" @click="unsubscribe">{{ __('Add') }}</button>
        </div>
        <p class="readable-text" v-if="unsubscribed !== null && unsubscribed.length == 0">
            {{ __('No emails are in the unsubscribed list.') }}
        </p>
        <table class="table" v-if="unsubscribed !== null">
            <tbody>
                <tr v-for="email in unsubscribed" :key="email.email_id">
                    <td>
                        {{ email.email }}
                    </td>
                    <td class="text-right">
                        <button class="btn btn-default btn-rounded" @click="removeUnsubscribe(email)"><i class="fa fa-times"></i></button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import SurveysService from "../../services/surveys-service";
export default {
    data() {
        return {
            unsubscribed: null,
            newEmail: ''
        }
    },
    mounted() {
        this.getUnsubscribed();
    },
    methods: {
        async unsubscribe() {
            await SurveysService.emails.unsubscribe(this.newEmail);
            this.getUnsubscribed();
        },
        async getUnsubscribed() {
            this.unsubscribed = await SurveysService.emails.getUnsubscribed();
        },
        async removeUnsubscribe(email) {
            swal({
                title: `Are you sure you want to remove this email from the unsubscribed list?`,
                text: "The action will be applied right away!",
                icon: "danger",
                showCancelButton: true,
                confirmButtonColor: "#cd3537",
                cancelButtonColor: "#d33",
                confirmButtonText: "Remove"
            }, async (result) => {
                if (result) {
                    await SurveysService.emails.removeUnsubscribe(email.id);
                    this.getUnsubscribed();
                }
            });
        }
    }
}
</script>

<style scoped>
    .unsub-input input {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    .unsub-input button {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
</style>